import { createAction, props } from '@ngrx/store';
import { ItemDetail } from '@emm/core/models/item-detail.model';

export enum ItemDetailAction {

    Load = '[Item Detail Effects] Load Item Detail',
    LoadFailure = '[Menu API] Load Item Detail Failure',
    LoadSuccess = '[Menu API] Load Item Detail Success',

    UpdateMenuItem = '[Menu Form] Update Menu Item',
    UpdateMenuItemSuccess = '[Menu API] Update Menu Item Success',
    UpdateItemLocaleSuccess = '[Menu API] Update Item Locale Success',
    UpdateMenuItemFailure = '[Menu API] Update Menu Item Failure',

    Add = '[Menu Tree] Add Item',
    AddFailure = '[Menu API] Add Item Failure',
    AddSuccess = '[Menu API] Add Item Success',

    ToggleDisabled = '[Menu Tree] Toggle Item Disabled',
    ToggleDisabledFailure = '[Menu API] Toggle Item Disabled Failure',
    ToggleDisabledSuccess = '[Menu API] Toggle Item Disabled Success',

    ToggleDisabledMenuWide = '[Menu Tree] Toggle Item Disabled Menu Wide',
    ToggleDisabledMenuWideFailure = '[Menu API] Toggle Item Disabled Menu Wide Failure',
    ToggleDisabledMenuWideSuccess = '[Menu API] Toggle Item Disabled Menu Wide Success',

    Delete = '[Menu Tree] Delete Item',
    DeleteFailure = '[Menu API] Delete Item Failure',
    DeleteSuccess = '[Menu API] Delete Item Success',

    DeleteWithoutReload = '[Menu Tree] Delete Item, No Reload',
    DeleteWithoutReloadFailure = '[Menu API] Delete Item Failure',
    DeleteWithoutReloadSuccess = '[Menu API] Delete Item Success',

    PasteCascade = '[Menu Tree] Paste Item Cascade',
    PasteCascadeFailure = '[Menu API] Paste Item Cascade Failure',
    PasteCascadeSuccess = '[Menu API] Paste Item Cascade Success',

    DeleteCascade = '[Menu Tree] Delete Item Cascade',
    DeleteCascadeFailure = '[Menu API] Delete Item Cascade Failure',
    DeleteCascadeSuccess = '[Menu API] Delete Item Cascade Success',

    Copy = '[Menu Tree] Copy Item',
    CopyFailure = '[Menu API] Copy Item Failure',
    CopySuccess = '[Menu API] Copy Item Success',

    Paste = '[Menu Tree] Paste Item',
    PasteFailure = '[Menu Tree] Paste Item Failure',
    PasteSuccess = '[Menu Tree] Paste Item Success',

    Move = '[Menu Tree] Move Item',
    MoveFailure = '[Menu Tree] Move Item Failure',
    MoveSuccess = '[Menu Tree] Move Item Success',

    AddLocalAttribute = '[Menu Form] Add Local Attribute',
    RemoveLocalAttribute = '[Menu Form] Remove Local Attribute',
    UpdateCascade = '[Menu Form] Update Item Cascade',
    UpdateCascadeSuccess = '[Menu API] Update Item Cascade Success',
    UpdateCascadeFailure = '[Menu API] Update Item Cascade Failure',

    SelectCascadeSubmenus = '[Cascade] Select Submenu',
    SelectCascadeSubmenusSuccess = '[Cascade] Select Submenu Success',
    SelectCascadeSubmenusFailure = '[Cascade] Select Submenu Failure',

    DeselectCascadeSubmenus = '[Cascade] Deselect Submenu',
    DeselectCascadeSubmenusSuccess = '[Cascade] Deselect Submenu Success',
    DeselectCascadeSubmenusFailure = '[Cascade] Deselect Submenu Failure',

    ResetCascadeSubmenus = '[Cascade] Reset Cascade Submenus',
    ResetCascadeSubmenusSuccess = '[Cascade] Reset Cascade Submenus Success',
    ResetCascadeSubmenusFailure = '[Cascade] Reset Cascade Submenus Failure',
}

export const ItemDetailActions = {
    load: createAction(ItemDetailAction.Load, props<{ path: string }>()),
    loadSuccess: createAction(ItemDetailAction.LoadSuccess, props<{ item: ItemDetail }>()),
    loadFailure: createAction(ItemDetailAction.LoadFailure, props<{ error: any }>()),
    updateMenuItem: createAction(
        ItemDetailAction.UpdateMenuItem,
        props<{ item: ItemDetail; updates: any; dispatchReload: boolean, forceOverrideInheritance: boolean,
            forceOverrideInheritanceMap?: any }>()
    ),
    updateMenuItemSuccess: createAction(
        ItemDetailAction.UpdateMenuItemSuccess,
        props<{ item: ItemDetail; dispatchReload: boolean }>()
    ),
    updateItemLocaleSuccess: createAction(
        ItemDetailAction.UpdateItemLocaleSuccess,
        props<{ item: ItemDetail; dispatchReload: boolean }>()
    ),
    updateMenuItemFailure: createAction(ItemDetailAction.UpdateMenuItemFailure, props<{ error: any }>()),
    add: createAction(ItemDetailAction.Add, props<{ parent: ItemDetail; children: Array<ItemDetail> }>()),
    addSuccess: createAction(ItemDetailAction.AddSuccess),
    addFailure: createAction(ItemDetailAction.AddFailure, props<{ error: any }>()),
    toggleDisabled: createAction(
        ItemDetailAction.ToggleDisabled,
        props<{ path: string; updates: { disabled: boolean }; cascade: boolean, forceOverrideInheritance: boolean }>()
    ),
    toggleDisabledSuccess: createAction(ItemDetailAction.ToggleDisabledSuccess),
    toggleDisabledFailure: createAction(ItemDetailAction.ToggleDisabledFailure, props<{ error: any }>()),
    toggleDisabledMenuWide: createAction(
        ItemDetailAction.ToggleDisabledMenuWide,
        props<{ path: string; updates: { disabled: boolean }; cascade: boolean, forceOverrideInheritance: boolean }>()
    ),
    toggleDisabledMenuWideSuccess: createAction(ItemDetailAction.ToggleDisabledMenuWideSuccess),
    toggleDisabledMenuWideFailure: createAction(
        ItemDetailAction.ToggleDisabledMenuWideFailure,
        props<{ error: any }>()
    ),
    delete: createAction(ItemDetailAction.Delete, props<{ path: string; itemName: string, selectedItem: ItemDetail }>()),
    deleteSuccess: createAction(ItemDetailAction.DeleteSuccess, props<{ itemName: string, path: string, dispatchReload: boolean }>()),
    deleteFailure: createAction(ItemDetailAction.DeleteFailure, props<{ error: any }>()),
    deleteWithoutReload: createAction(ItemDetailAction.DeleteWithoutReload, props<{ path: string; itemName: string }>()),
    deleteWithoutReloadSuccess: createAction(ItemDetailAction.DeleteWithoutReloadSuccess, props<{ itemName: string }>()),
    deleteWithoutReloadFailure: createAction(ItemDetailAction.DeleteWithoutReloadFailure, props<{ error: any }>()),
    pasteCascade: createAction(
        ItemDetailAction.PasteCascade,
        props<{ submenuTag: string; parentTag: string; childTagPath: string; selectedItem: ItemDetail, position: string }>()
    ),
    pasteCascadeSuccess: createAction(ItemDetailAction.PasteCascadeSuccess, props<{ path: string; dispatchReload: boolean }>()),
    pasteCascadeFailure: createAction(ItemDetailAction.PasteCascadeFailure, props<{ error: any }>()),
    deleteCascade: createAction(ItemDetailAction.DeleteCascade, props<{ path: string, selectedItem: ItemDetail }>()),
    deleteCascadeSuccess: createAction(ItemDetailAction.DeleteCascadeSuccess, props<{ path: string; dispatchReload: boolean }>()),
    deleteCascadeFailure: createAction(ItemDetailAction.DeleteCascadeFailure, props<{ error: any }>()),
    copy: createAction(ItemDetailAction.Copy, props<{ fromPath: string }>()),
    copySuccess: createAction(ItemDetailAction.CopySuccess),
    copyFailure: createAction(ItemDetailAction.CopyFailure, props<{ error: any }>()),
    paste: createAction(ItemDetailAction.Paste, props<{ fromPath: string; toPath: string }>()),
    pasteSuccess: createAction(ItemDetailAction.PasteSuccess),
    pasteFailure: createAction(ItemDetailAction.PasteFailure, props<{ error: any }>()),
    move: createAction(ItemDetailAction.Move, props<{ fromPath: string; toPath: string, index: string }>()),
    moveSuccess: createAction(ItemDetailAction.MoveSuccess),
    moveFailure: createAction(ItemDetailAction.MoveFailure, props<{ error: any }>()),
    addLocalAttribute: createAction(ItemDetailAction.AddLocalAttribute, props<{ attributeIndex: number }>()),
    removeLocalAttribute: createAction(
        ItemDetailAction.RemoveLocalAttribute,
        props<{ attributeIndex: number }>()
    ),
    updateCascade: createAction(ItemDetailAction.UpdateCascade, props<{ path: string; cascadePath: string | object; updates: any,
        forceOverrideInheritance: boolean, forceOverrideInheritanceMap?: any}>()),
    updateCascadeSuccess: createAction(ItemDetailAction.UpdateCascadeSuccess, props<{ path: string }>()),
    updateCascadeFailure: createAction(ItemDetailAction.UpdateCascadeFailure, props<{ error: any }>()),

    selectCascadeSubmenus: createAction(ItemDetailAction.SelectCascadeSubmenus, props <{selectedSubmenuTag: string}>()),
    selectCascadeSubmenusSuccess: createAction(ItemDetailAction.SelectCascadeSubmenusSuccess),
    selectCascadeSubmenusFailure: createAction(ItemDetailAction.SelectCascadeSubmenusFailure, props <{error: any}>()),

    deselectCascadeSubmenus: createAction(ItemDetailAction.DeselectCascadeSubmenus, props <{selectedSubmenuTag: string}>()),
    deselectCascadeSubmenusSuccess: createAction(ItemDetailAction.DeselectCascadeSubmenusSuccess),
    deselectCascadeSubmenusFailure: createAction(ItemDetailAction.DeselectCascadeSubmenusFailure, props <{error: any}>()),

    resetCascadeSubmenus: createAction(ItemDetailAction.ResetCascadeSubmenus),
    resetCascadeSubmenusSuccess: createAction(ItemDetailAction.ResetCascadeSubmenusSuccess),
    resetCascadeSubmenusFailure: createAction(ItemDetailAction.ResetCascadeSubmenusFailure, props <{error: any}>()),
};

export const ItemDetailAsyncActions = {
    loadActions: [
        ItemDetailActions.load,
        ItemDetailActions.updateMenuItem,
        ItemDetailActions.add,
        ItemDetailActions.toggleDisabled,
        ItemDetailActions.toggleDisabledMenuWide,
        ItemDetailActions.delete,
        ItemDetailActions.pasteCascade,
        ItemDetailActions.deleteCascade,
        ItemDetailActions.copy,
        ItemDetailActions.paste,
        ItemDetailActions.move,
        ItemDetailActions.updateCascade,
        ItemDetailActions.selectCascadeSubmenus,
        ItemDetailActions.deselectCascadeSubmenus,
        ItemDetailActions.resetCascadeSubmenus,
    ],
    successActions: [
        ItemDetailActions.loadSuccess,
        ItemDetailActions.updateMenuItemSuccess,
        ItemDetailActions.addSuccess,
        ItemDetailActions.toggleDisabledSuccess,
        ItemDetailActions.toggleDisabledMenuWideSuccess,
        ItemDetailActions.deleteSuccess,
        ItemDetailActions.pasteCascadeSuccess,
        ItemDetailActions.deleteCascadeSuccess,
        ItemDetailActions.copySuccess,
        ItemDetailActions.pasteSuccess,
        ItemDetailActions.moveSuccess,
        ItemDetailActions.updateCascadeSuccess,
        ItemDetailActions.selectCascadeSubmenusSuccess,
        ItemDetailActions.deselectCascadeSubmenusSuccess,
        ItemDetailActions.resetCascadeSubmenusSuccess,
    ],
    errorActions: [
        ItemDetailActions.loadFailure,
        ItemDetailActions.updateMenuItemFailure,
        ItemDetailActions.addFailure,
        ItemDetailActions.toggleDisabledFailure,
        ItemDetailActions.toggleDisabledMenuWideFailure,
        ItemDetailActions.deleteFailure,
        ItemDetailActions.pasteCascadeFailure,
        ItemDetailActions.deleteCascadeFailure,
        ItemDetailActions.copyFailure,
        ItemDetailActions.pasteFailure,
        ItemDetailActions.moveFailure,
        ItemDetailActions.updateCascadeFailure,
        ItemDetailActions.selectCascadeSubmenusFailure,
        ItemDetailActions.deselectCascadeSubmenusFailure,
        ItemDetailActions.resetCascadeSubmenusFailure,
    ]
};
